import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import close from '../Asset/close.svg';
import { Form, Modal } from "react-bootstrap";
import { Tabs, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, PieChart, Cell, CartesianGrid, Tooltip, Pie, Sector, Legend, ResponsiveContainer } from "recharts";
import { getUserInfo, getDashboard } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

const srTypeColor = ["#273043", "#A6BE45"];
const avgYtdColor = ["#0077B9", "#A6BE45", "#C12065"];
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};


function Service_Request() {
  let tdate = new Date();
  var dd = String(tdate.getDate()).padStart(2, '0');
  var mm = String(tdate.getMonth() + 1).padStart(2, '0');
  var yyyy = String(tdate.getFullYear());

  const dashboard = sessionStorage.getItem('Dashboards') ? getDashboard() : [];
  let userObj = getUserInfo();
  let [sessOut, setSessOut] = useState(false);
  let [today, setToday] = useState("");
  let [years, setYears] = useState([]);
  let [filterDash, setFilterDash] = useState(null);
  let [filter, setFilter] = useState({
    equipmentID: "",
    equipmentType: "",
    siteID: "",
    fromDate: "",
    toDate: "",
    month: "",
    year: "",
    productCategoryID: "",
    productSubCategoryID: "",
  });
  let [filterDefault, setFilterDefault] = useState({
    201: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    202: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    203: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    205: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: String(yyyy)
    },
    206: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
    },
    207: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
    },
    208: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: String(yyyy)
    },
  })
  let [filterHis, setFilterHis] = useState({
    201: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    202: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    203: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: "",
      month: "",
      fromDate: yyyy + "-" + mm + "-" + dd,
      toDate: yyyy + "-" + mm + "-" + dd,
    },
    205: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: String(yyyy)
    },
    206: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
    },
    207: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
    },
    208: {
      equipmentID: "",
      productCategoryID: "",
      productSubCategoryID: "",
      equipmentType: "",
      siteID: "",
      year: String(yyyy)
    },
  })
  useEffect(() => {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    let abortController = new AbortController();
    let today = new Date();
    ////console.log("Today;", today);
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();

    setToday(yyyy + "-" + mm + "-" + dd);
    let tempy = [];
    for (let i = 0; i < 3; i++) {
      tempy.push(yyyy - i);
    }
    setYears(tempy);

    if (globObj && globObj != 'undefined') {
      setFilter(globObj);
      saveGlobelFilter('store', globObj);
    }
    else {
      if (dashboard.indexOf(201) >= 0) {
        getEqupimentData(filterHis[201]);
      }
      if (dashboard.indexOf(202) >= 0) {
        getSrTypeData(filterHis[202]);//fromDate: yyyy + "-" + mm + "-" + dd + "T00:00:00.000Z"
      }
      if (dashboard.indexOf(203) >= 0) {
        getProductWise(filterHis[203]);
      }
      if (dashboard.indexOf(205) >= 0) {
        getAvgSrClosureTime(filterHis[205]);
      }
      if (dashboard.indexOf(206) >= 0) {
        getTimeDrillDown(filterHis[206]);
      }
      if (dashboard.indexOf(207) >= 0) {
        getAvgClosureTime(filterHis[207]);
      }
      if (dashboard.indexOf(208) >= 0) {
        getbreakDown(filterHis[208]);
      }
    }

    getProductCategory();
    getDropDown();
    getSiteList();

    return () => {
      abortController.abort();
    }
  }, [])

  let [cate, setCate] = useState([]);
  let [subCate, setSubCate] = useState([]);
  let [siteList, setSiteList] = useState([]);
  let [allAseet, setAllAsset] = useState([]);

  let [dropdownData, setDropDownData] = useState({
    asset_equipmentType: [
      { name: "" },
    ]
  });

  const [activeIndex, setActiveIndex] = useState(0);
  const onPieEnter = useCallback(
    (_, index) => {
      setActiveIndex(index);
    },
    [setActiveIndex]
  );

  function getProductCategory() {
    fetch(environment.baseUrl + "getProductCategory?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        ////console.log("Category:", resp)
        if (resp.code == 200) {
          setCate(resp.data.result.categories);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setCate([]);
        }
      })
    })
  }
  function getProductSubCategory(pid) {
    fetch(environment.baseUrl + "getProductSubCategory?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          "parentID": pid
        })
    }).then((result) => {
      result.json().then(res => {
        ////console.log("SubCategory:", res.data.result.subCategories);
        if (res.code == 200) {
          setSubCate(res.data.result.subCategories);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSubCate([]);
        }
      })
    })
  }

  function getDropDown() {
    fetch(environment.baseUrl + "getDropDown", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "groupName": ["equipmentType"],
        "masterType": ["asset"]
      })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setDropDownData(res.data.result);
          ////console.log("***** Dropdown Values*******", dropdownData.asset_productCategory);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setDropDownData({
            asset_equipmentType: [
              { name: "" },
            ]
          })
        }
      })
    })
  }
  function getSiteList() {
    fetch(environment.baseUrl + "getSiteByUserAccount", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        //console.log("getsite:", resp)
        if (resp.code == 200) {
          setSiteList(resp.data.result.siteList);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setSiteList([]);
        }
      })
    })
  }
  function getAssetList() {
    fetch(environment.baseUrl + "getEquipmentsByUser", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then((res) => {
        //console.log(res);
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }

  function getEquipmentBySite(sid) {
    fetch(environment.baseUrl + "getEquipmentBySite?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          siteID: sid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }

  let [equipementData, setequipementData] = useState([]);
  let [srTypeData, setsrTypeData] = useState([]);
  let [productWiseData, setProductWiseData] = useState([]);
  let [srClosureTime, setsrClosureTime] = useState([]);
  let [srDrillDownTime, setDrillDownTime] = useState([]);
  let [srClosureTimeYTD, setsrClosureTimeYTD] = useState([]);
  let [breakDown, setbreakDown] = useState([]);


  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setSubCate([]);
    setFilter({
      equipmentID: "",
      equipmentType: "",
      siteID: "",
      fromDate: "",
      toDate: "",
      month: "",
      year: "",
      productCategoryID: "",
      productSubCategoryID: "",
    });
  };
  const handleShow = (dashID) => {
    setFilterDash(dashID);
    setFilter(filterHis[dashID]);
    if (filterHis[dashID].siteID == "") {
      getAssetList();
    }
    else {
      getEquipmentBySite(filterHis[dashID].siteID);
    }
    if (filterHis[dashID].productCategoryID != "") {
      getProductSubCategory(filterHis[dashID].productCategoryID)
    }
    setShow(true);
    //console.log("dashID:", dashID);
  }

  function clearFilter(dashID) {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    setAllAsset([]);

    if (globObj && globObj != 'undefined') {
      sessionStorage.removeItem('GloberFilter');
      getEqupimentData(filterDefault[201]);
      getSrTypeData(filterDefault[202]);
      getProductWise(filterDefault[203]);
      getAvgSrClosureTime(filterDefault[205]);
      getTimeDrillDown(filterDefault[206]);
      getAvgClosureTime(filterDefault[207]);
      getbreakDown(filterDefault[208]);

      setFilterHis({
        201: filterDefault[201],
        202: filterDefault[202],
        203: filterDefault[203],
        205: filterDefault[205],
        206: filterDefault[206],
        207: filterDefault[207],
        208: filterDefault[208]
      });
    }
    else {
      setFilterHis({ ...filterHis, [dashID]: filterDefault[dashID] });
      if (dashID == 201) {
        getEqupimentData(filterDefault[201]);
      }
      if (dashID == 202) {
        getSrTypeData(filterDefault[202]);//fromDate: yyyy + "-" + mm + "-" + dd + "T00:00:00.000Z"
      }
      if (dashID == 203) {
        getProductWise(filterDefault[203]);
      }
      if (dashID == 205) {
        getAvgSrClosureTime(filterDefault[205]);
      }
      if (dashID == 206) {
        getTimeDrillDown(filterDefault[206]);
      }
      if (dashID == 207) {
        getAvgClosureTime(filterDefault[207]);
      }
      if (dashID == 208) {
        getbreakDown(filterDefault[208]);
      }
    }

    handleClose();

  }

  function getFilterData(e) {
    if (e.target.name === "productCategoryID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      getProductSubCategory(parseInt(e.target.value));
    }
    else if (e.target.name === "productSubCategoryID" || e.target.name === "siteID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      if (e.target.name === "siteID") {
        getEquipmentBySite(e.target.value);
      }
    }
    else if (e.target.name == "fromDate") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "" });
    }
    else if (e.target.name == "toDate") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "" });
    }
    else if (e.target.name == "month") {
      setFilter({ ...filter, [e.target.name]: e.target.value, year: "", fromDate: "", toDate: "" });
    }
    else if (e.target.name == "year") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", fromDate: "", toDate: "" });
    }
    else {
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
  }

  function getFilterFields() {
    setFilterHis({ ...filterHis, [filterDash]: filter })
    ////console.log("FILTERDATA", filter);
    if (filterDash == 201) {
      getEqupimentData(filter);
    }
    else if (filterDash == 202) {
      getSrTypeData(filter);
    }
    else if (filterDash == 203) {
      getProductWise(filter);
    }
    else if (filterDash == 205) {
      getAvgSrClosureTime(filter);
    }
    else if (filterDash == 206) {
      getTimeDrillDown(filter);
    }
    else if (filterDash == 207) {
      getAvgClosureTime(filter);
    }
    else {
      getbreakDown(filter);
    }
  }

  function getEqupimentData(obj) {
    fetch(environment.baseUrl + "equipmentOnIOTPlatformReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          dateFrom: obj.fromDate != "" ? obj.fromDate + " 00:00:00" : "",
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          dateTo: obj.toDate != "" ? obj.toDate + " 23:59:59" : "",
          month: obj.month,
          year: obj.year,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID
        })
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.equipmentOnIotPlateform.forEach(element => {
            newTemp.push({ name: element[0], "Total SRs": element[1], "Open SRs": element[2] })
          });
          setequipementData(newTemp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setequipementData([])
        }
        handleClose();
        ////console.log("equipmentOnIOTPlateformReport:", res);
      })
    })
  }

  function getSrTypeData(obj) {
    fetch(environment.baseUrl + "listSRsCountByType", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          dateFrom: obj.fromDate != "" ? obj.fromDate + " 00:00:00" : "",
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          dateTo: obj.toDate != "" ? obj.toDate + " 23:59:59" : "",
          month: obj.month,
          year: obj.year,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID
        }
      )
    }).then((result) => {
      result.json().then((res) => {
        let temp = [];
        if (res.code == 200) {
          res.data.chartData.map((item) =>
            temp.push({ name: item[0], value: item[1] })
          )
          //console.log(temp);
          setsrTypeData(temp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setsrTypeData([]);
        }
        handleClose();
        ////console.log("listSRsCountByType?:", res);
      })
    })
  }

  function getProductWise(obj) {
    fetch(environment.baseUrl + "productCategoryWiseSrReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          dateFrom: obj.fromDate != "" ? obj.fromDate + " 00:00:00" : "",
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          dateTo: obj.toDate != "" ? obj.toDate + " 23:59:59" : "",
          month: obj.month,
          year: obj.year,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID,
        }
      )
    }).then((result) => {
      result.json().then((res) => {
        let newTemp = [];
        if (res.code == 200) {
          res.data.productCategoryWiseSR.forEach(element => {
            newTemp.push({ 'name': element[0], 'totalSr': element[1] })
          });
          setProductWiseData(newTemp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setProductWiseData([]);
        }
        handleClose();
      })
    })
  }

  function getAvgSrClosureTime(obj) {
    fetch(environment.baseUrl + "avgSrClosureTimeTrendReport"
      , {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + userObj.token
        }, body: JSON.stringify(
          {
            equipmentID: obj.equipmentID,
            equipmentType: obj.equipmentType,
            siteID: obj.siteID,
            year: obj.year,
            productCategoryID: obj.productCategoryID,
            productSubCategoryID: obj.productSubCategoryID
          })
      }).then((result) => {
        result.json().then((res) => {
          let temp = [];
          if (res.code == 200) {
            res.data.avgSrClosureTimeTrend.map((item) =>
              temp.push({ month: item[0], "Diesel": item[1], "Electric": item[2], "Other": item[3], })
            )
            setsrClosureTime(temp);
          }
          else if (res.code == 401) {
            setSessOut(true);
          }
          else {
            setsrClosureTime([]);
          }
          handleClose();
          ////console.log("avgSrClosureTimeTrendReport:", res);
        })
      })
  }

  function getTimeDrillDown(obj) {
    fetch(environment.baseUrl + "srClosureTimeDrilldownReport"
      , {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + userObj.token
        }, body: JSON.stringify(
          {
            equipmentID: obj.equipmentID,
            equipmentType: obj.equipmentType,
            siteID: obj.siteID,
            productCategoryID: obj.productCategoryID,
            productSubCategoryID: obj.productSubCategoryID
          }
        )
      }).then((result) => {
        result.json().then((res) => {
          let newTemp = [];
          if (res.code == 200) {
            res.data.srClosureTimeDrilldown.forEach(element => {
              newTemp.push({
                'name': element[0], 'diesel': element[1], 'electric': element[2], 'other': element[3]
              })
            });
            setDrillDownTime(newTemp);
          }
          else if (res.code == 401) {
            setSessOut(true);
          }
          else {
            setDrillDownTime([]);
          }
          handleClose();
          ////console.log("srClosureTimeDrilldown:", res);
        })
      })
  }

  function getAvgClosureTime(obj) {
    fetch(environment.baseUrl + "avgSrClosureTime"
      , {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + userObj.token
        }, body: JSON.stringify(
          {
            equipmentID: obj.equipmentID,
            equipmentType: obj.equipmentType,
            siteID: obj.siteID,
            productCategoryID: obj.productCategoryID,
            productSubCategoryID: obj.productSubCategoryID
          })
      }).then((result) => {
        result.json().then((res) => {
          let color = ["#0077B9", "#6FA624", "#C12065"];
          let temp = [];
          if (res.code == 200) {
            res.data.avgSrClousureTime.map((item, index) =>
              //temp.push({ name: item[0], value: item[1], fill: color[index] })
              temp.push({ name: item[0], value: item[1] })
            )
            //console.log(temp);
            setsrClosureTimeYTD(temp);
          }
          else if (res.code == 401) {
            setSessOut(true);
          }
          else {
            setsrClosureTimeYTD([]);
          }
          handleClose();
          ////console.log("avgSrClousureTime?:", res);
        })
      })
  }

  function getbreakDown(obj) {
    fetch(environment.baseUrl + "srBreakdownMonthWiseReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }, body: JSON.stringify(
        {
          equipmentID: obj.equipmentID,
          equipmentType: obj.equipmentType,
          siteID: obj.siteID,
          year: obj.year,
          productCategoryID: obj.productCategoryID,
          productSubCategoryID: obj.productSubCategoryID
        })
    }).then((result) => {
      result.json().then((res) => {
        let temp = [];
        if (res.code == 200) {
          res.data.srBreakdownMonthWise.map((item) =>
            temp.push({ name: item[0], Breakdown: item[1] })
          )
          setbreakDown(temp);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setbreakDown([]);
        }
        handleClose();
        ////console.log("srBreakdownMonthWiseReport:", res);
      })
    })
  }
  function checkDurFilter(filObj) {
    if (filObj.fromDate != "" || filObj.toDate != "" || filObj.year != "" || filObj.month != "") {
      // console.log("in iffff");
      return true;
    }
    else {
      // console.log("in elllse")
      return false
    }
  }
  function saveGlobelFilter(type, obj) {
    let val = {}, flag = false, filObj;
    if (type == "store") {
      val = obj;
    }
    else {
      sessionStorage.setItem("GloberFilter", JSON.stringify({
        equipmentID: filter.equipmentID ? filter.equipmentID : "",
        equipmentType: filter.equipmentType ? filter.equipmentType : "",
        siteID: filter.siteID ? filter.siteID : "",
        fromDate: filter.fromDate ? filter.fromDate : "",
        toDate: filter.toDate ? filter.toDate : "",
        month: filter.month ? filter.month : "",
        year: filter.year ? filter.year : "",
        productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
        productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
      }));
      val = {
        equipmentID: filter.equipmentID ? filter.equipmentID : "",
        equipmentType: filter.equipmentType ? filter.equipmentType : "",
        siteID: filter.siteID ? filter.siteID : "",
        fromDate: filter.fromDate ? filter.fromDate : "",
        toDate: filter.toDate ? filter.toDate : "",
        month: filter.month ? filter.month : "",
        year: filter.year ? filter.year : "",
        productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
        productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
      };
    }
    flag = checkDurFilter(val);
    filObj = {
      201: flag ? val : {
        equipmentID: val.equipmentID,
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year,
        month: val.month,
        fromDate: yyyy + "-" + mm + "-" + dd,
        toDate: yyyy + "-" + mm + "-" + dd,
      },
      202: flag ? val : {
        equipmentID: val.equipmentID,
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year,
        month: val.month,
        fromDate: yyyy + "-" + mm + "-" + dd,
        toDate: yyyy + "-" + mm + "-" + dd,
      },
      203: flag ? val : {
        equipmentID: val.equipmentID,
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year,
        month: val.month,
        fromDate: yyyy + "-" + mm + "-" + dd,
        toDate: yyyy + "-" + mm + "-" + dd,
      },
      205: {
        equipmentID: val.equipmentID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year != "" ? val.year : String(yyyy),
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID
      },
      206: val,
      207: val,
      208: {
        equipmentID: val.equipmentID,
        equipmentType: val.equipmentType,
        siteID: val.siteID,
        year: val.year != "" ? val.year : String(yyyy),
        productCategoryID: val.productCategoryID,
        productSubCategoryID: val.productSubCategoryID
      }
    }
    setFilterHis(filObj);
    // dashList.forEach(element => {
    // });
    allApiCall(filObj);
    // console.log(val);
  }
  function allApiCall(req) {
    if (dashboard.indexOf(201) >= 0) {
      getEqupimentData(req[201]);
    }
    if (dashboard.indexOf(202) >= 0) {
      getSrTypeData(req[202]);
    }
    if (dashboard.indexOf(203) >= 0) {
      getProductWise(req[203]);
    }
    if (dashboard.indexOf(205) >= 0) {
      getAvgSrClosureTime(req[205]);
    }
    if (dashboard.indexOf(206) >= 0) {
      getTimeDrillDown(req[206]);
    }
    if (dashboard.indexOf(207) >= 0) {
      getAvgClosureTime(req[207]);
    }
    if (dashboard.indexOf(208) >= 0) {
      getbreakDown(req[208]);
    }
  }
  return (
    <div className='main-container'>
      <SessionFun show={sessOut}></SessionFun>
      <h4 className='main-heading'>Service Request</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Service Request</p>
      <div className="row">
        <Tabs className='tab-menu' defaultActiveKey="first" id="uncontrolled-tab-example">
          <Tab eventKey="first" title="Service Requests Analysis">
            <div className="row mt-3">
              {
                dashboard.indexOf(201) == -1 ? "" :
                  <div className="col-sm-6 left-col">
                    <div className="card-box-block">
                      <div className="row">
                        <div className="col-sm-10">
                          <h6 className='cardtitle'>Equipment with SRs</h6>
                        </div>
                        <div className="col-sm-2  text-end">
                          <FontAwesomeIcon icon={faBars} onClick={() => handleShow(201)} />
                        </div>
                      </div>
                      <hr />
                      {
                        equipementData.length ?
                          <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                              data={equipementData}
                              margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 3
                              }}
                              barSize={20}
                            >
                              <CartesianGrid vertical={false} strokeDasharray="3 3" /> TO <CartesianGrid vertical={false} strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Bar dataKey="Total SRs" fill="#273043" />
                              <Bar dataKey="Open SRs" fill="#C12065" />
                            </BarChart>
                          </ResponsiveContainer>
                          :
                          <p className='text-center'><b>No Data Available</b></p>
                      }
                    </div>
                  </div>
              }
              {
                dashboard.indexOf(202) == -1 ? "" :
                  <div className="col-sm-6 card-box-block">
                    <div className="row">
                      <div className="col-sm-10">
                        <h6 className='cardtitle'>SR Type</h6>
                      </div>
                      <div className="col-sm-2  text-end">
                        <FontAwesomeIcon icon={faBars} onClick={() => handleShow(202)} />
                      </div>
                    </div>
                    <hr />
                    {
                      srTypeData.length ?
                        <ResponsiveContainer width="100%" height={300}>
                          <PieChart>
                            <Legend />
                            <Pie
                              data={srTypeData}
                              cx="50%"
                              cy="50%"
                              labelLine={false}
                              label={renderCustomizedLabel}
                              outerRadius={80}
                              fill="#8884d8"
                              dataKey="value"
                            >
                              {srTypeData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={srTypeColor[index % srTypeColor.length]} />
                              ))}
                            </Pie>
                          </PieChart>
                        </ResponsiveContainer>
                        :
                        <p className='text-center'><b>No service request raised during selected date range </b></p>
                    }
                  </div>
              }


            </div>
            {
              dashboard.indexOf(203) == -1 ? "" :
                <div className="row mt-3">
                  <div className="col-sm-12 full-col">
                    <div className="card-box-block">
                      <div className="row">
                        <div className="col-sm-10">
                          <h6 className='cardtitle'>Product Category Wise SR</h6>
                        </div>
                        <div className="col-sm-2  text-end">
                          <FontAwesomeIcon icon={faBars} onClick={() => handleShow(203)} />
                        </div>
                      </div>
                      <hr />
                      {
                        productWiseData.length ?
                          <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                              data={productWiseData}
                              margin={{
                                top: 20,
                                right: 30,
                                left: 10,
                                bottom: 5
                              }}
                              barSize={20}
                            >
                              <CartesianGrid vertical={false} strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Bar name='Total SRs' dataKey="totalSr" fill="#2196F3" />
                            </BarChart>
                          </ResponsiveContainer>
                          :
                          <p className='text-center'><b>No Data Available</b></p>
                      }

                    </div>
                  </div>
                </div>
            }

          </Tab>
          <Tab eventKey="second" title="SR Closure Time Analysis">
            {
              dashboard.indexOf(205) == -1 ? "" :
                <div className="row mt-3">
                  <div className="col-sm-12 full-col">
                    <div className="card-box-block">
                      <div className="row">
                        <div className="col-sm-10">
                          <h6 className='cardtitle'>Avg. SR Closure Time Trend {":"+filterHis['205'].year}</h6>
                        </div>
                        <div className="col-sm-2  text-end">
                          <FontAwesomeIcon icon={faBars} onClick={() => handleShow(205)} />
                        </div>
                      </div>
                      {
                        srClosureTime.length ?
                          <ResponsiveContainer width="100%" height={300}>
                            <LineChart
                              data={srClosureTime}
                              margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                              }}
                            >
                              <CartesianGrid vertical={false} strokeDasharray="3 3" />
                              <XAxis dataKey="month" />
                              <YAxis />
                              <Tooltip />
                              <Legend iconType="square" />
                              <Line name="SRs Diesel" type="monotone" dataKey="Diesel" stroke="#0077B9" activeDot={{ r: 8 }} />
                              <Line name="SRs Electric" type="monotone" dataKey="Electric" stroke="#A6BE45" />
                              <Line name="SRs Other" type="monotone" dataKey="Other" stroke="#C12065" />
                            </LineChart>
                          </ResponsiveContainer>
                          :
                          <p className='text-center'><b>No Data Available</b></p>
                      }
                    </div>
                  </div>
                </div>
            }


            <div className="row mt-3">
              {
                dashboard.indexOf(206) == -1 ? "" :
                  <div className="col-sm-6 left-col">
                    <div className="card-box-block">
                      <div className="row">
                        <div className="col-sm-10">
                          <h6 className='cardtitle'>SR Closure Time Drilldown(YTD)</h6>
                        </div>
                        <div className="col-sm-2  text-end">
                          <FontAwesomeIcon icon={faBars} onClick={() => handleShow(206)} />
                        </div>
                      </div>
                      <hr />
                      {
                        srDrillDownTime.length ?
                          <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                              data={srDrillDownTime}
                              margin={{
                                top: 20,
                                right: 30,
                                left: 10,
                                bottom: 5
                              }}
                              barSize={20}
                            >
                              <CartesianGrid vertical={false} strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Bar name="SRs Diesel" dataKey="diesel" fill="#0077B9" />
                              <Bar name="SRs Electric" dataKey="electric" fill="#B0BC00" />
                              <Bar name="SRs Other" dataKey="other" fill="#C12065" />

                            </BarChart>
                          </ResponsiveContainer>
                          :
                          <p className='text-center'><b>No Data Available</b></p>
                      }
                    </div>
                  </div>
              }
              {
                dashboard.indexOf(207) == -1 ? "" :
                  <div className="col-sm-6 card-box-block">
                    <div className="row">
                      <div className="col-sm-10">
                        <h6 className='cardtitle'>Avg. SR Closure Time(YTD)</h6>
                      </div>
                      <div className="col-sm-2  text-end">
                        <FontAwesomeIcon icon={faBars} onClick={() => handleShow(207)} />
                      </div>
                    </div>
                    <hr />
                    {
                      srClosureTimeYTD.length ?
                        <ResponsiveContainer width="100%" height={300}>
                          <BarChart
                            data={srClosureTimeYTD}
                            margin={{
                              top: 20,
                              right: 30,
                              left: 10,
                              bottom: 5
                            }}
                            barSize={20}
                          >
                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Bar name='Value' dataKey="value" fill="#0077B9" />
                          </BarChart>
                        </ResponsiveContainer>
                        :
                        <p className='text-center'><b>No Data Available</b></p>
                    }
                  </div>
              }
            </div>

          </Tab>
          <Tab eventKey="third" title="Breakdown">
            {
              dashboard.indexOf(208) == -1 ? "" :
                <div className="row card-box-block mt-3">
                  <div className="col-sm-12 full-col">
                    <div className="row">
                      <div className="col-sm-10">
                        <h6 className='cardtitle'>Breakdown Trend {":"+filterHis['208'].year}</h6>
                      </div>
                      <div className="col-sm-2  text-end">
                        <FontAwesomeIcon icon={faBars} onClick={() => handleShow(208)} />
                      </div>
                    </div>
                    <hr />
                    {
                      breakDown.length ?
                        <ResponsiveContainer width="100%" height={300}>
                          <LineChart
                            data={breakDown}
                            margin={{
                              top: 5,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid vertical={false} strokeDasharray="3 3" />
                            <XAxis dataKey="name" />
                            <YAxis />
                            <Tooltip />
                            <Line type="monotone" dataKey="Breakdown" stroke="#0077B9" activeDot={{ r: 8 }} />

                          </LineChart>
                        </ResponsiveContainer>
                        :
                        <p className='text-center'><b>No Data Available</b></p>
                    }
                  </div>
                </div>
            }

          </Tab>
        </Tabs>
      </div>

      {/* /////////////////Product Category Wise SR///////////////////////////// */}

      <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title>Filter</Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <div className='row'>
            {
              filterDash == 201 || filterDash == 202 || filterDash == 203 ?
                <>
                  <div className='col-sm-4'>
                    <Form.Group className="mb-2" >
                      <Form.Label>From Date</Form.Label>
                      <Form.Control type='date' placeholder='fromDate' name='fromDate' value={filter.fromDate} max={yyyy+"-"+mm+"-"+dd}
                        className="textbox-back" onChange={getFilterData} />
                    </Form.Group>
                  </div>
                  <div className='col-sm-4'>
                    <Form.Group className="mb-2" >
                      <Form.Label>To Date</Form.Label>
                      <Form.Control type='date' placeholder='toDate' name='toDate' value={filter.toDate} min={filter.fromDate} max={yyyy+"-"+mm+"-"+dd}
                        className="textbox-back" onChange={getFilterData} />
                    </Form.Group>
                  </div>
                  <div className='col-sm-4'>
                    <Form.Group className="mb-2" >
                      <Form.Label>Month</Form.Label>
                      <Form.Control type='month' placeholder='month' name='month' value={filter.month} max={yyyy+"-"+mm}
                        className="textbox-back" onChange={getFilterData} />
                    </Form.Group>
                  </div>
                </>
                :
                ""
            }
            {
              filterDash == 201 || filterDash == 202 || filterDash == 203 || filterDash == 205 || filterDash == 208 ?
                <div className='col-sm-4'>
                  <Form.Group className="mb-2 " >
                    <Form.Label>Year</Form.Label>
                    <Form.Select as='select' placeholder='year' name='year' value={filter.year}
                      className="textbox-back" onChange={getFilterData}>
                      <option value="">Select Year</option>
                      {
                        years.map((item, index) =>
                          <option key={index} value={item}>{item}</option>
                        )
                      }
                    </Form.Select>
                  </Form.Group>
                </div>
                :
                ""
            }
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Category</label>
                <Form.Select as='select' name='productCategoryID' className="textbox-back" value={filter.productCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    cate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Sub Category</label>
                <Form.Select as='select' name='productSubCategoryID' className="textbox-back" value={filter.productSubCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    subCate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Site</label>
                <Form.Select as='select' name='siteID' className="textbox-back" value={filter.siteID} onChange={getFilterData}>
                  <option value="">Select Site</option>
                  {
                    siteList.map((item, index) =>
                      <option key={index} value={item.siteID}>{item.siteName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <label>Equipment ID</label>
                <Form.Select as='select' name='equipmentID' className="textbox-back" value={filter.equipmentID} onChange={getFilterData}>
                  <option value="">Select Equipment ID</option>
                  {
                    allAseet.map((item, index) =>
                      <option key={index} value={item.assetID}>{item.assetID}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Equipment Type</label>
                <Form.Select as='select' name='equipmentType' className="textbox-back" value={filter.equipmentType} onChange={getFilterData}>
                  <option value="">Select Equipment Type</option>
                  {
                    (dropdownData.asset_equipmentType).map((item, index) =>
                      <option key={index} value={item.name}>{item.name}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <button className="btn btn-outline-secondary lo-btn" onClick={() => clearFilter(filterDash)}>
              Reset
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn mx-3" onClick={getFilterFields}>
              Apply
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn" onClick={saveGlobelFilter}>
              Apply All
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>

  )
}


export default Service_Request
